
document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-accordion]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const panel=btn.nextElementSibling;
      const open=btn.getAttribute('aria-expanded')==='true';
      btn.setAttribute('aria-expanded',String(!open));
      panel.hidden=open;
    });
  });
  document.querySelectorAll('.reveal-card').forEach(card=>{
    card.setAttribute('tabindex','0');
    const toggle=()=>card.classList.toggle('is-open');
    card.addEventListener('click',toggle);
    card.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle();}});
  });
  const selector=document.querySelector('[data-variant-select]');
  if(selector){
    const price=document.querySelector('[data-product-price]');
    const button=document.querySelector('[data-add-button]');
    selector.addEventListener('change',()=>{
      const opt=selector.options[selector.selectedIndex];
      if(price && opt.dataset.price) price.textContent=opt.dataset.price;
      if(button) button.disabled=opt.disabled;
    });
  }
  const modal=document.querySelector('[data-buy-modal]');
  if(modal){
    const openers=document.querySelectorAll('[data-open-buy-modal]');
    const closers=modal.querySelectorAll('[data-close-buy-modal]');
    const status=modal.querySelector('[data-buy-status]');
    const success=modal.querySelector('[data-buy-success]');
    let lastTrigger=null;
    const openModal=(trigger)=>{
      lastTrigger=trigger;
      modal.hidden=false;
      document.body.classList.add('modal-open');
      const closeButton=modal.querySelector('.buy-modal__close');
      if(closeButton) closeButton.focus();
    };
    const closeModal=()=>{
      modal.hidden=true;
      document.body.classList.remove('modal-open');
      if(lastTrigger) lastTrigger.focus();
    };
    openers.forEach(btn=>btn.addEventListener('click',()=>openModal(btn)));
    closers.forEach(btn=>btn.addEventListener('click',closeModal));
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!modal.hidden)closeModal();});

    const addVariant=async(variantId,goToCheckout=false,button=null)=>{
      if(!variantId) return;
      if(status){status.textContent='Wird hinzugefügt …';status.classList.remove('is-error');}
      if(success) success.hidden=true;
      if(button) button.disabled=true;
      try{
        const response=await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
        });
        if(!response.ok){const data=await response.json().catch(()=>({}));throw new Error(data.description||'Das Produkt konnte nicht hinzugefügt werden.');}
        if(goToCheckout){window.location.assign('/checkout');return;}
        if(status) status.textContent='';
        if(success) success.hidden=false;
        await window.use2FlyToCart?.(button);
        const cartCount=document.querySelector('[data-cart-count]');
        if(cartCount){
          const cart=await fetch('/cart.js').then(r=>r.json());
          cartCount.textContent=cart.item_count;
        }
      }catch(error){
        if(status){status.textContent=error.message||'Es ist ein Fehler aufgetreten.';status.classList.add('is-error');}
      }finally{if(button) button.disabled=false;}
    };
    modal.querySelectorAll('[data-add-variant]').forEach(btn=>btn.addEventListener('click',()=>addVariant(btn.dataset.addVariant,false,btn)));
    modal.querySelectorAll('[data-buy-now]').forEach(btn=>btn.addEventListener('click',()=>addVariant(btn.dataset.buyNow,true,btn)));
  }

  const io=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('visible');io.unobserve(entry.target);}});
  },{threshold:.12});
  document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
});

/* Launch Edition homepage interactions */
document.addEventListener('DOMContentLoaded',()=>{
  const intro=document.querySelector('.u2-intro');
  if(intro){
    const already=sessionStorage.getItem('use2IntroSeen');
    if(already){intro.remove();}
    else{
      sessionStorage.setItem('use2IntroSeen','1');
      window.setTimeout(()=>intro.classList.add('is-hidden'),1850);
      window.setTimeout(()=>intro.remove(),2600);
    }
  }
  document.querySelectorAll('[data-u2-360]').forEach(viewer=>{
    const images=[...viewer.querySelectorAll('[data-u2-frame]')];
    const controls=[...viewer.querySelectorAll('[data-u2-control]')];
    controls.forEach((button,index)=>{
      button.addEventListener('click',()=>{
        images.forEach((img,i)=>img.classList.toggle('is-active',i===index));
        controls.forEach((btn,i)=>btn.classList.toggle('is-active',i===index));
      });
    });
  });
});

/* Theme-only product reviews: immediate display in the visitor's browser. */
document.addEventListener('DOMContentLoaded',()=>{
  const section=document.querySelector('[data-product-reviews]');
  if(!section) return;
  const form=section.querySelector('[data-review-form]') || section.querySelector('#Use2ReviewForm');
  const list=section.querySelector('[data-review-list]');
  const empty=section.querySelector('[data-review-empty]');
  const averageEl=section.querySelector('[data-review-average]');
  const starsEl=section.querySelector('[data-review-stars]');
  const countEl=section.querySelector('[data-review-count]');
  const success=section.querySelector('[data-review-success]');
  const storageKey='use2ProductReviewsV10';
  const escapeHtml=value=>String(value).replace(/[&<>'"]/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[ch]));
  const getReviews=()=>{try{return JSON.parse(localStorage.getItem(storageKey)||'[]');}catch(e){return [];}};
  const saveReviews=reviews=>{try{localStorage.setItem(storageKey,JSON.stringify(reviews.slice(0,50)));}catch(e){}};
  const render=()=>{
    const reviews=getReviews();
    list.querySelectorAll('.use2-customer-review').forEach(card=>card.remove());
    if(empty) empty.hidden=reviews.length>0;
    reviews.forEach(review=>{
      const card=document.createElement('article');
      card.className='use2-customer-review';
      card.innerHTML=`<div class="use2-customer-review__top"><div class="use2-customer-review__stars" aria-label="${review.rating} von 5 Sternen">${'★'.repeat(review.rating)}${'☆'.repeat(5-review.rating)}</div><time>${escapeHtml(review.date)}</time></div><h4>${escapeHtml(review.title)}</h4><p>${escapeHtml(review.message)}</p><strong>${escapeHtml(review.name)}</strong><span class="use2-customer-review__verified">Produktbewertung</span>`;
      list.appendChild(card);
    });
    if(reviews.length){
      const avg=reviews.reduce((sum,item)=>sum+Number(item.rating),0)/reviews.length;
      averageEl.textContent=avg.toFixed(1).replace('.',',');
      starsEl.textContent='★'.repeat(Math.round(avg))+'☆'.repeat(5-Math.round(avg));
      starsEl.setAttribute('aria-label',`${avg.toFixed(1)} von 5 Sternen`);
      countEl.textContent=`${reviews.length} ${reviews.length===1?'Produktbewertung':'Produktbewertungen'}`;
    }else{
      averageEl.textContent='–'; starsEl.textContent='☆☆☆☆☆'; countEl.textContent='Noch keine Produktbewertungen';
    }
  };
  render();
  if(form){
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(!form.reportValidity()) return;
      const selected=form.querySelector('[data-rating-value]:checked');
      if(!selected) return;
      const review={
        name:form.querySelector('[data-review-name]').value.trim(),
        title:form.querySelector('[data-review-title]').value.trim(),
        message:form.querySelector('[data-review-message]').value.trim(),
        rating:Number(selected.dataset.ratingValue),
        date:new Intl.DateTimeFormat('de-DE',{day:'2-digit',month:'2-digit',year:'numeric'}).format(new Date())
      };
      const reviews=getReviews(); reviews.unshift(review); saveReviews(reviews); render();
      if(success) success.hidden=false;
      try{await fetch(form.action,{method:'POST',body:new FormData(form),headers:{'Accept':'text/html'}});}catch(e){}
      form.reset();
      list.scrollIntoView({behavior:'smooth',block:'start'});
    });
  }
});

/* Generic purchase modals used by additional USE2 products. */
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-generic-buy-modal]').forEach(modal=>{
    if(modal.dataset.initialized==='true') return;
    modal.dataset.initialized='true';
    const openers=document.querySelectorAll(`[data-open-modal="${modal.id}"]`);
    const closers=modal.querySelectorAll('[data-close-generic-modal]');
    const status=modal.querySelector('[data-generic-status]');
    const success=modal.querySelector('[data-generic-success]');
    let lastTrigger=null;
    const openModal=(trigger)=>{lastTrigger=trigger;modal.hidden=false;document.body.classList.add('modal-open');modal.querySelector('.buy-modal__close')?.focus();};
    const closeModal=()=>{modal.hidden=true;document.body.classList.remove('modal-open');lastTrigger?.focus();};
    openers.forEach(btn=>btn.addEventListener('click',()=>openModal(btn)));
    closers.forEach(btn=>btn.addEventListener('click',closeModal));
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!modal.hidden) closeModal();});
    const addVariant=async(variantId,checkout,button)=>{
      if(!variantId) return;
      if(status){status.textContent='Wird hinzugefügt …';status.classList.remove('is-error');}
      if(success) success.hidden=true;
      if(button) button.disabled=true;
      try{
        const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})});
        const data=await response.json().catch(()=>({}));
        if(!response.ok) throw new Error(data.description||'Das Produkt konnte nicht hinzugefügt werden.');
        if(checkout){window.location.assign('/checkout');return;}
        if(status) status.textContent='';
        if(success) success.hidden=false;
        await window.use2FlyToCart?.(button);
        const cartCount=document.querySelector('[data-cart-count]');
        if(cartCount){const cart=await fetch('/cart.js').then(r=>r.json());cartCount.textContent=cart.item_count;}
      }catch(error){if(status){status.textContent=error.message||'Es ist ein Fehler aufgetreten.';status.classList.add('is-error');}}
      finally{if(button) button.disabled=false;}
    };
    modal.querySelectorAll('[data-generic-add]').forEach(btn=>btn.addEventListener('click',()=>addVariant(btn.dataset.genericAdd,false,btn)));
    modal.querySelectorAll('[data-generic-buy-now]').forEach(btn=>btn.addEventListener('click',()=>addVariant(btn.dataset.genericBuyNow,true,btn)));
  });
});

/* V18 – cart quantities and global count synchronization */
document.addEventListener('DOMContentLoaded',()=>{
  const syncCartCount=async()=>{
    try{
      const response=await fetch('/cart.js',{headers:{'Accept':'application/json'}});
      if(!response.ok) return;
      const cart=await response.json();
      document.querySelectorAll('[data-cart-count]').forEach(node=>{node.textContent=cart.item_count;});
      document.querySelectorAll('.floating-cart').forEach(link=>link.setAttribute('aria-label',`Warenkorb öffnen, ${cart.item_count} Artikel`));
    }catch(error){}
  };
  syncCartCount();

  document.querySelectorAll('[data-quantity-selector]').forEach(selector=>{
    const input=selector.querySelector('[data-quantity-input]');
    const minus=selector.querySelector('[data-quantity-minus]');
    const plus=selector.querySelector('[data-quantity-plus]');
    const line=selector.closest('[data-cart-line]');
    const quantityText=line?.querySelector('.cart-row__quantity-text');
    if(!input) return;
    let timer;
    const money=cents=>new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format((Number(cents)||0)/100);
    const updateCart=async next=>{
      const lineNumber=Number(line?.dataset.cartLineIndex||0);
      if(!lineNumber) return;
      selector.classList.add('is-updating');
      try{
        const response=await fetch('/cart/change.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({line:lineNumber,quantity:next})
        });
        if(!response.ok) throw new Error('Cart update failed');
        const cart=await response.json();
        if(next===0){ line?.remove(); }
        else{
          const item=cart.items[lineNumber-1];
          if(item){
            const price=line?.querySelector('[data-cart-line-price]');
            if(price) price.textContent=money(item.final_line_price);
          }
        }
        document.querySelectorAll('[data-cart-count]').forEach(node=>node.textContent=cart.item_count);
        const count=document.querySelector('.cart-page__count');
        if(count) count.textContent=`${cart.item_count} Artikel`;
        const grand=document.querySelector('[data-cart-grand-total]');
        if(grand) grand.textContent=money(cart.total_price);
        document.querySelectorAll('[data-use2-cart-total]').forEach(node=>node.textContent=money(cart.total_price));
        const threshold=4500, remaining=Math.max(0,threshold-cart.total_price);
        document.querySelectorAll('[data-use2-cart-status]').forEach(panel=>{
          const msg=panel.querySelector('[data-use2-shipping-message]');
          const detail=panel.querySelector('[data-use2-shipping-detail]');
          const progress=panel.querySelector('[data-use2-shipping-progress]');
          if(msg) msg.textContent=cart.total_price>=threshold?'Perfekt! Deine Bestellung ist jetzt versandkostenfrei.':`Noch ${money(remaining)} bis zum kostenlosen Versand.`;
          if(detail) detail.textContent=cart.total_price>=threshold?'Für diese Bestellung fallen keine Versandkosten an.':'Bis 44,99 €: 5,99 € versicherter Versand.';
          if(progress) progress.style.width=`${Math.min(100,(cart.total_price/threshold)*100)}%`;
        });
        if(cart.item_count===0) location.reload();
      }catch(error){ location.reload(); }
      finally{ selector.classList.remove('is-updating'); }
    };
    const setValue=value=>{
      const next=Math.max(0,Number.parseInt(value,10)||0);
      input.value=String(next);
      if(quantityText) quantityText.textContent=`${next}× bestellt`;
      updateCart(next);
    };
    minus?.addEventListener('click',()=>setValue(Number(input.value)-1));
    plus?.addEventListener('click',()=>setValue(Number(input.value)+1));
    input.addEventListener('input',()=>{
      if(Number(input.value)<0) input.value='0';
      if(quantityText) quantityText.textContent=`${input.value || 0}× bestellt`;
      clearTimeout(timer);
      timer=setTimeout(()=>updateCart(Math.max(0,Number.parseInt(input.value,10)||0)),350);
    });
  });
});

/* V23 – five-product pricing, Ajax cart and free-shipping status */
document.addEventListener('DOMContentLoaded',()=>{
  const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  const formatMoney=cents=>new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format((Number(cents)||0)/100);
  const updateStatus=async()=>{
    try{
      const response=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'}});
      if(!response.ok) return;
      const cart=await response.json();
      document.querySelectorAll('[data-cart-count]').forEach(node=>node.textContent=cart.item_count);
      document.querySelectorAll('[data-use2-cart-status]').forEach(panel=>{
        const threshold=4500;
        const remaining=Math.max(0,threshold-cart.total_price);
        panel.querySelector('[data-use2-cart-total]')?.replaceChildren(document.createTextNode(formatMoney(cart.total_price)));
        const message=panel.querySelector('[data-use2-shipping-message]');
        const detail=panel.querySelector('[data-use2-shipping-detail]');
        const progress=panel.querySelector('[data-use2-shipping-progress]');
        if(cart.total_price>=threshold){
          if(message) message.textContent='Perfekt! Deine Bestellung ist jetzt versandkostenfrei.';
          if(detail) detail.textContent='Für diese Bestellung fallen keine Versandkosten an.';
        }else{
          if(message) message.textContent=`Noch ${formatMoney(remaining)} bis zum kostenlosen Versand.`;
          if(detail) detail.textContent='Bis 44,99 €: 5,99 € versicherter Versand.';
        }
        if(progress) progress.style.width=`${Math.min(100,(cart.total_price/threshold)*100)}%`;
      });
    }catch(error){}
  };

  document.querySelectorAll('[data-use2-add]').forEach(button=>{
    button.addEventListener('click',async()=>{
      const status=button.parentElement.querySelector('.use2-action-status');
      let items=[];
      try{items=JSON.parse(button.dataset.items||'[]').filter(item=>Number(item.id)>0);}catch(error){}
      if(!items.length){if(status) status.textContent='Bitte zuerst das passende Produkt im Theme-Editor zuordnen.';return;}
      const oldLabel=button.textContent;
      button.disabled=true;
      button.textContent='Wird hinzugefügt …';
      if(status) status.textContent='';
      try{
        const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const data=await response.json().catch(()=>({}));
        if(!response.ok) throw new Error(data.description||'Das Produkt konnte nicht hinzugefügt werden.');
        if(status) status.textContent=items.length>1?'Perfekte Kombination wurde hinzugefügt.':'Zum Warenkorb hinzugefügt.';
        window.use2FlyToCart?.(button);
        await updateStatus();
      }catch(error){if(status) status.textContent=error.message||'Es ist ein Fehler aufgetreten.';}
      finally{button.disabled=false;button.textContent=oldLabel;}
    });
  });
  updateStatus();
});

/* USE2 premium interaction and scroll progress */
document.addEventListener('DOMContentLoaded',()=>{
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const progress=document.querySelector('.u2-scroll-progress');
  const glow=document.querySelector('.u2-cursor-glow');
  const hero=document.querySelector('.hero');
  const setProgress=()=>{
    const max=document.documentElement.scrollHeight-innerHeight;
    const value=max>0?(scrollY/max)*100:0;
    document.documentElement.style.setProperty('--u2-progress',`${value}%`);
  };
  setProgress(); addEventListener('scroll',setProgress,{passive:true});
  if(reduced) return;

  let gx=innerWidth/2,gy=innerHeight/2,cx=gx,cy=gy;
  const animateGlow=()=>{cx+=(gx-cx)*.12;cy+=(gy-cy)*.12;if(glow)glow.style.transform=`translate3d(${cx}px,${cy}px,0) translate(-50%,-50%)`;requestAnimationFrame(animateGlow)};
  if(glow){animateGlow();document.addEventListener('pointermove',e=>{gx=e.clientX;gy=e.clientY;document.documentElement.style.setProperty('--hx',`${e.clientX/innerWidth*100}%`);document.documentElement.style.setProperty('--hy',`${e.clientY/innerHeight*100}%`);},{passive:true});}

  if(hero){hero.addEventListener('pointermove',e=>{if(innerWidth<901)return;const r=hero.getBoundingClientRect();const x=(e.clientX-r.left)/r.width-.5;const y=(e.clientY-r.top)/r.height-.5;hero.style.setProperty('--u2-hero-x',`${x*-18}px`);hero.style.setProperty('--u2-hero-y',`${y*-12}px`);hero.style.setProperty('--u2-copy-x',`${x*10}px`);hero.style.setProperty('--u2-copy-y',`${y*7}px`);});hero.addEventListener('pointerleave',()=>{['--u2-hero-x','--u2-hero-y','--u2-copy-x','--u2-copy-y'].forEach(v=>hero.style.setProperty(v,'0px'));});}

  document.querySelectorAll('.problem-card,.benefit,.reveal-card,.feature-media').forEach(card=>{
    card.addEventListener('pointermove',e=>{if(innerWidth<901)return;const r=card.getBoundingClientRect();const px=(e.clientX-r.left)/r.width;const py=(e.clientY-r.top)/r.height;const rx=(.5-py)*5;const ry=(px-.5)*6;card.style.setProperty('--card-x',`${px*100}%`);card.style.setProperty('--card-y',`${py*100}%`);card.style.transform=`perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-5px)`;});
    card.addEventListener('pointerleave',()=>card.style.transform='');
  });

  document.querySelectorAll('.btn').forEach(btn=>{btn.addEventListener('pointermove',e=>{if(innerWidth<901)return;const r=btn.getBoundingClientRect();const x=(e.clientX-r.left-r.width/2)*.10;const y=(e.clientY-r.top-r.height/2)*.14;btn.style.translate=`${x}px ${y}px`;});btn.addEventListener('pointerleave',()=>btn.style.translate='');});
});

/* USE2 Teamkauf */
document.addEventListener('DOMContentLoaded',()=>{
  const modal=document.querySelector('[data-team-buy-modal]');
  if(!modal)return;
  const openers=document.querySelectorAll('[data-open-team-modal]');
  const closers=modal.querySelectorAll('[data-close-team-modal]');
  const black=modal.querySelector('[data-team-qty="black"]');
  const white=modal.querySelector('[data-team-qty="white"]');
  const total=modal.querySelector('[data-team-total]');
  const stripes=modal.querySelector('[data-team-stripes]');
  const price=modal.querySelector('[data-team-price]');
  const status=modal.querySelector('[data-team-status]');
  const submit=modal.querySelector('[data-team-add]');
  const money=n=>new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(n);
  const clean=input=>{input.value=Math.max(0,parseInt(input.value||0,10)||0);return Number(input.value)};
  const update=()=>{const b=clean(black),w=clean(white),t=b+w;total.textContent=t;stripes.textContent=t*10;price.textContent=money(t*17.95);if(submit)submit.disabled=t<5;};
  const open=()=>{modal.hidden=false;document.body.classList.add('modal-open');update();modal.querySelector('.buy-modal__close')?.focus()};
  const close=()=>{modal.hidden=true;document.body.classList.remove('modal-open')};
  openers.forEach(b=>b.addEventListener('click',open));closers.forEach(b=>b.addEventListener('click',close));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!modal.hidden)close()});
  [black,white].filter(Boolean).forEach(i=>i.addEventListener('input',update));
  modal.querySelectorAll('[data-team-plus]').forEach(b=>b.addEventListener('click',()=>{const i=b.dataset.teamPlus==='black'?black:white;i.value=clean(i)+1;update()}));
  modal.querySelectorAll('[data-team-minus]').forEach(b=>b.addEventListener('click',()=>{const i=b.dataset.teamMinus==='black'?black:white;i.value=Math.max(0,clean(i)-1);update()}));
  modal.querySelectorAll('[data-team-preset]').forEach(b=>b.addEventListener('click',()=>{black.value=Number(b.dataset.teamPreset);white.value=0;update()}));
  submit?.addEventListener('click',async()=>{
    const b=clean(black),w=clean(white),t=b+w;if(t<5){status.textContent='Der Teamkauf startet ab 5 Bändern.';status.classList.add('is-error');return;}
    const team=modal.querySelector('[data-team-name]')?.value.trim()||'Teamkauf';
    const contact=modal.querySelector('[data-team-contact]')?.value.trim()||'';
    const properties={'Bestellart':'Teamkauf','Verein / Team':team};if(contact)properties['Ansprechpartner']=contact;
    const items=[];if(b)items.push({id:Number(submit.dataset.blackId),quantity:b,properties});if(w)items.push({id:Number(submit.dataset.whiteId),quantity:w,properties});
    submit.disabled=true;const old=submit.textContent;submit.textContent='TEAM-BESTELLUNG WIRD HINZUGEFÜGT …';status.textContent='';status.classList.remove('is-error');
    try{const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const data=await r.json().catch(()=>({}));if(!r.ok)throw new Error(data.description||'Die Team-Bestellung konnte nicht hinzugefügt werden.');await window.use2FlyToCart?.(submit);window.location.assign('/cart');}
    catch(e){status.textContent=e.message||'Es ist ein Fehler aufgetreten.';status.classList.add('is-error');submit.disabled=false;submit.textContent=old;}
  });
});

/* V24 – exact Schwarz/Weiß selection for all three USE2 offers */
document.addEventListener('DOMContentLoaded',()=>{
  const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  document.querySelectorAll('[data-use2-color-group]').forEach(group=>{
    group.querySelectorAll('.use2-color-options').forEach(options=>{
      options.querySelectorAll('[data-use2-color]').forEach(btn=>btn.addEventListener('click',()=>{
        options.querySelectorAll('[data-use2-color]').forEach(x=>{x.classList.remove('is-active');x.setAttribute('aria-pressed','false');});
        btn.classList.add('is-active');btn.setAttribute('aria-pressed','true');
      }));
    });
  });
  document.querySelectorAll('[data-use2-color-add]').forEach(button=>button.addEventListener('click',async()=>{
    const scope=button.closest('.use2-offer-card,.use2-presale-bundle');
    const status=scope?.querySelector('.use2-action-status');
    const choices=[...(scope?.querySelectorAll('.use2-color-options')||[])].map(box=>box.querySelector('[data-use2-color].is-active')?.dataset.use2Color||'Schwarz');
    let items;
    if(button.dataset.use2ColorAdd==='bundle') {
      const id=Number(button.dataset.bundleId)||0;
      if(!id){if(status)status.textContent='Dieses Bundle ist noch nicht verfügbar.';return;}
      items=[{id,quantity:1,properties:{'Band 1':choices[0],'Band 2':choices[1],'_use2_bundle':button.dataset.bundleKind}}];
    } else {
      const id=Number(choices[0]==='Weiß'?button.dataset.whiteId:button.dataset.blackId)||0;
      if(!id){if(status)status.textContent='Die gewählte Farbe ist noch nicht verfügbar.';return;}
      items=[{id,quantity:1}];
    }
    const old=button.textContent;button.disabled=true;button.textContent='Wird hinzugefügt …';if(status)status.textContent='';
    try{const r=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});const data=await r.json().catch(()=>({}));if(!r.ok)throw new Error(data.description||'Das Produkt konnte nicht hinzugefügt werden.');if(status)status.textContent=`Hinzugefügt: ${choices.join(' + ')}`;window.use2FlyToCart?.(button);document.dispatchEvent(new Event('use2:cart-updated'));const cart=await fetch(`${root}cart.js`).then(x=>x.json());document.querySelectorAll('[data-cart-count]').forEach(x=>x.textContent=cart.item_count);}catch(e){if(status)status.textContent=e.message||'Es ist ein Fehler aufgetreten.';}finally{button.disabled=false;button.textContent=old;}
  }));
});

/* V25 – premium fly-to-cart feedback for every successful AJAX add */
(()=>{
  window.use2FlyToCart=(source)=>new Promise(resolve=>{
    const cart=document.querySelector('.floating-cart')||document.querySelector('.cart-pill');
    if(!source||!cart||window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      cart?.classList.add('use2-cart-hit');setTimeout(()=>cart?.classList.remove('use2-cart-hit'),600);resolve();return;
    }
    const a=source.getBoundingClientRect(),b=cart.getBoundingClientRect();
    const flyer=document.createElement('div');
    flyer.className='use2-cart-fly';
    flyer.setAttribute('aria-hidden','true');
    flyer.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1"/><circle cx="19" cy="20" r="1"/><path d="M3 4h2l2.4 10.1a2 2 0 0 0 2 1.5h7.9a2 2 0 0 0 1.9-1.4L21 8H7"/></svg>';
    const sx=a.left+a.width/2,sy=a.top+a.height/2,ex=b.left+b.width/2,ey=b.top+b.height/2;
    flyer.style.left=sx+'px';flyer.style.top=sy+'px';document.body.appendChild(flyer);
    const dx=ex-sx,dy=ey-sy;
    const anim=flyer.animate([
      {transform:'translate(-50%,-50%) scale(.55)',opacity:0},
      {transform:'translate(-50%,-50%) scale(1.08)',opacity:1,offset:.14},
      {transform:`translate(calc(-50% + ${dx*.58}px),calc(-50% + ${dy*.28-55}px)) scale(.78)`,opacity:1,offset:.58},
      {transform:`translate(calc(-50% + ${dx}px),calc(-50% + ${dy}px)) scale(.18)`,opacity:.15}
    ],{duration:760,easing:'cubic-bezier(.2,.72,.2,1)',fill:'forwards'});
    anim.onfinish=()=>{flyer.remove();cart.classList.remove('use2-cart-hit');void cart.offsetWidth;cart.classList.add('use2-cart-hit');const count=cart.querySelector('[data-cart-count]')||document.querySelector('.floating-cart__count');count?.classList.remove('use2-count-pop');if(count){void count.offsetWidth;count.classList.add('use2-count-pop');}setTimeout(()=>{cart.classList.remove('use2-cart-hit');count?.classList.remove('use2-count-pop');},650);resolve();};
    anim.oncancel=()=>{flyer.remove();resolve();};
  });
})();

/* V26 – reliable cart badge after every successful add/change */
(()=>{
  const nativeFetch=window.fetch.bind(window);
  let revision=0;
  let refreshTimer;
  const root=(window.Shopify?.routes?.root||'/');
  const render=count=>{
    if(!Number.isFinite(Number(count))) return;
    const n=Math.max(0,Number(count));
    document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=String(n);});
    document.querySelectorAll('.floating-cart').forEach(el=>el.setAttribute('aria-label',`Warenkorb öffnen, ${n} Artikel`));
  };
  const refresh=async()=>{
    const current=++revision;
    try{
      const response=await nativeFetch(`${root}cart.js`,{cache:'no-store',credentials:'same-origin',headers:{Accept:'application/json'}});
      if(!response.ok) return;
      const cart=await response.json();
      if(current===revision) render(cart.item_count);
    }catch(e){/* Keep the last confirmed count if temporarily offline. */}
  };
  window.use2RefreshCartCount=refresh;
  window.fetch=async function(input,init){
    const response=await nativeFetch(input,init);
    const url=typeof input==='string'?input:input?.url||'';
    const path=(()=>{try{return new URL(url,location.href).pathname;}catch(e){return '';}})();
    if(response.ok && /\/cart\/(add|change|update|clear)\.js$/.test(path)){
      ++revision;
      clearTimeout(refreshTimer);
      // Update immediately, then once more after other concurrent handlers finish.
      void refresh();
      refreshTimer=setTimeout(refresh,300);
    }
    return response;
  };
  document.addEventListener('use2:cart-updated',refresh);
  document.addEventListener('DOMContentLoaded',refresh);
  window.addEventListener('pageshow',refresh);
})();
